import { cn } from "@/lib/utils";

interface DRiskifyLogoProps {
  className?: string;
  decorative?: boolean;
}

export function DRiskifyLogo({
  className,
  decorative = false,
}: DRiskifyLogoProps) {
  return (
    <img
      src="/images/brand/logo-v2.svg"
      alt={decorative ? "" : "DRiskify"}
      aria-hidden={decorative ? "true" : undefined}
      className={cn("h-auto w-36", className)}
    />
  );
}
